<mat-card>
    <h2>Review your event</h2>

    <p>Please take the time to review your event. To change information, please use the edit button.</p>
    <br />
    <div class="reviewcontainer">
        <h3>Organiser Details</h3>
        <div class="row">
            <div class="col-md-6 col-lg-3">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>First Name</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.organiserVm.firstname)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-6 col-lg-3">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Surname</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.organiserVm.surname)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-6 col-lg-3">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Email Address</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.organiserVm.email)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-6 col-lg-3">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Contact Phone</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.organiserVm.phone)" readonly>
                </mat-form-field>
            </div>
        </div>
        <button mat-button (click)="editFormInfo(0)" class="btn btn-secondary" type="button"
            aria-label="Edit Organiser Details" matTooltip="Edit Organiser Details">Edit</button>
    </div>
    <div class="reviewcontainer">
        <h3>Event Details</h3>
        <div class="row">
            <div class="col-md-12 col-lg-6">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Event Name</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.detailVm.name)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-12 col-lg-6">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Event Type</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.detailVm.eventType)" readonly>
                </mat-form-field>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Category</mat-label>
                    <input matInput [value]="getCategoriesToReviewScreen(this.vm.detailVm.category).join(', ')" readonly>
                </mat-form-field>
            </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-md-12 col-lg-4">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Occurrence</mat-label>
                    <input matInput [value]="getOccurrenceLabel(this.vm.detailVm.occurrenceType)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-12 col-lg-4">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Frequency</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.detailVm.frequency)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-12" *ngIf="this.vm.detailVm.frequency === 'Weekly' || this.vm.detailVm.frequency === 'TwoWeeks'">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Days of Week</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.detailVm.daysOfWeek.join(', '))" readonly>
                </mat-form-field>
            </div>

        </div> -->
        <!-- <div class="row">
            <div class="col-md-6 col-lg-4" *ngIf="this.vm.detailVm.occurrenceType == 'OnceOff'">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Date of Event</mat-label>
                    <input matInput [value]="this.onceOffDateFormatted" readonly>
                </mat-form-field>
            </div>

            <div class="col-md-6 col-lg-4" *ngIf="this.vm.detailVm.occurrenceType == 'OccursBetween'">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Start Date</mat-label>

                    <input matInput [value]="this.dateStartFormatted" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-6 col-lg-4" *ngIf="this.vm.detailVm.occurrenceType == 'OccursBetween'">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>End Date</mat-label>
                    <input matInput [value]="this.dateEndFormatted" readonly>
                </mat-form-field>
            </div>
        </div> -->
        <div class="row">
            <div class="col-lg-12">
                <h5>Event Dates</h5>
                <div class="date-cards">
                    <div class="date-card" *ngFor="let date of this.vm.detailVm.eventDates">
                        <div class="date-card__month">{{ date.toLocaleString('en-IE', { month: 'short' }) }}</div>
                        <div class="date-card__day">{{ date.getDate() }}</div>
                        <div class="date-card__weekday">{{ date.toLocaleString('en-IE', { weekday: 'long' }) }}</div>
                        <div class="date-card__year">{{ date.getFullYear() }}</div>
                    </div>
                </div>
            </div>
        </div>
        <br /><br />
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Start Time</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.detailVm.timeStart)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-6 col-lg-4">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>End Time</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.detailVm.timeEnd)" readonly>
                </mat-form-field>
            </div>
        </div>
        <button mat-button (click)="editFormInfo(1)" class="btn btn-secondary" type="button"
            aria-label="Edit Event Details" matTooltip="Edit Event Details">Edit</button>
    </div>
    <div class="reviewcontainer">
        <h3>Event Description</h3>
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Teaser</mat-label>
                    <textarea matInput readonly [value]="getValueOrDefault(this.vm.descriptionVm.teaser)"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Description</mat-label>
                    <textarea rows="15" matInput readonly
                        [value]="getValueOrDefault(this.vm.descriptionVm.description)"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Description for search engines</mat-label>
                    <textarea rows="15" matInput readonly
                        [value]="getValueOrDefault(this.vm.descriptionVm.metadescription)"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Audience</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.descriptionVm.audience)" readonly>
                </mat-form-field>
            </div>
        </div>
        <button mat-button (click)="editFormInfo(1)" class="btn btn-secondary" type="button"
            aria-label="Edit Event Description" matTooltip="Edit Event Description">Edit</button>
    </div>

    <div class="reviewcontainer">
        <h3>Further information about your event</h3>

        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Link</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.channelsVm.website)" readonly>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Phone Number</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.channelsVm.phone)" readonly>
                </mat-form-field>
            </div>
        </div>

        <button mat-button (click)="editFormInfo(1)" class="btn btn-secondary" type="button"
            aria-label="Edit Event Channel" matTooltip="Edit Event Channel">Edit</button>
    </div>
    <div class="reviewcontainer">
        <h3>Location</h3>
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Name</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.venueVm.name)" readonly>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Address</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.venueVm.address)" readonly>
                </mat-form-field>
            </div>
        </div>

        <button mat-button (click)="editFormInfo(2)" class="btn btn-secondary" type="button" aria-label="Edit Venue"
            matTooltip="Edit Venue">Edit</button>
    </div>
    <div class="reviewcontainer">
        <h3>Booking</h3>
        <div class="row">
            <div class="col-md-12 col-lg-6">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Booking Website</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.bookingVm.bookingWebsite)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-12 col-lg-6">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Booking Phone</mat-label>
                    <mat-icon matSuffix>phone</mat-icon>
                    <input matInput [value]="getValueOrDefault(this.vm.bookingVm.bookingPhone)" readonly>
                </mat-form-field>
            </div>
        </div>
        <button mat-button (click)="editFormInfo(3)" class="btn btn-secondary" type="button" aria-label="Edit Booking"
            matTooltip="Edit Booking">Edit</button>
    </div>
    <div class="reviewcontainer">
        <h3>Pricing</h3>
        <div class="row">
            <div class="col-md-12 col-lg-6">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Admission Price</mat-label>
                    <input matInput [value]="getPricingModelViewValue(this.vm.pricingVm.admission)" readonly>
                </mat-form-field>
            </div>
            <div class="col-md-12 col-lg-6" *ngIf="this.vm.pricingVm.admission == 'paid'">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>General Admission Price</mat-label>
                    <mat-icon matSuffix>euro_symbol</mat-icon>
                    <input matInput [value]="getValueOrDefault(this.vm.pricingVm.generalAdmissionPrice)" readonly>
                </mat-form-field>
            </div>
        </div>
        <button mat-button (click)="editFormInfo(3)" class="btn btn-secondary" type="button" aria-label="Edit Pricing"
            matTooltip="Edit Pricing">Edit</button>
    </div>
    <div class="reviewcontainer">
        <h3>Images</h3>
        <!-- <div class="row">
            <div class="col-12">
                <ngx-gallery [options]="galleryOptions" [images]="galleryImages" *ngIf="this.galleryImages.length > 0"></ngx-gallery>
                <p *ngIf="this.galleryImages.length == 0">No images provided.</p>
            </div>
        </div> -->

        <!-- <div id="images" class='row d-flex imagescontainer'
            *ngIf="this.vm.imagesVm.images && this.vm.imagesVm.images.length > 0">

            <div class="col-md-12 col-lg-5 col-sm-12 imagecontainer" *ngFor="let image of this.vm.imagesVm.images">
                <img [src]="image.url" alt="{{image.caption}}" class="image">
                <div class="overlay" *ngIf="image.title">
                    {{image.title}}</div>
                <span>{{image.description}}</span>
            </div>

        </div> -->
        <div *ngIf="this.vm.imagesVm.images && this.vm.imagesVm.images.length > 0">
            <div class="row">
                <div class="col-md-6 col-lg-4 col-sm-12 imagecontainer" *ngFor="let image of this.vm.imagesVm.images">
                    <img [src]="image.url" alt="{{image.caption}}" class="image">
                    <br /><span><b>Title:</b> {{image.title}}</span>
                    <br /><span><b>Description:</b> {{image.description}}</span>
                    <!-- <div class="overlay" *ngIf="image.title">
                {{image.title}}</div>
            <span>{{image.description}}</span> -->
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!this.vm.imagesVm.images || this.vm.imagesVm.images.length == 0">
            <div class="col-12">
                <div>
                    <p>No images provided.</p>
                </div>
            </div>
        </div>


        <br />
        <button mat-button (click)="editFormInfo(4)" class="btn btn-secondary" type="button" aria-label="Edit Images"
            matTooltip="Edit Images">Edit</button>
    </div>
    <div class="reviewcontainer">
        <h3>Youtube Video</h3>
        <div class="row">
            <div class="col-12">
                <div class="video-thumbnail-select" *ngIf="this.vm.videoVm.videoThumbnail">
                    <img src="{{this.vm.videoVm.videoThumbnail}}" />
                </div>
                <div *ngIf="!this.vm.videoVm.videoThumbnail">
                    <p>No video provided.</p>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top:20px;" *ngIf="this.vm.videoVm.videoThumbnail">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Video Caption</mat-label>
                    <input matInput [value]="getValueOrDefault(this.vm.videoVm.videoCaption)" readonly>
                </mat-form-field>
            </div>
        </div>

        <br />
        <button mat-button (click)="editFormInfo(4)" class="btn btn-secondary" type="button" aria-label="Edit Video"
            matTooltip="Edit Video">Edit</button>
    </div>
</mat-card>